export type ClientCertificateExpiryState =
  | "not_configured"
  | "not_recorded"
  | "expired"
  | "expiring_soon"
  | "valid";

export type RegisteredConnectionAccessUiState =
  | "not_applicable"
  | "loading"
  | "connection_unavailable"
  | "certificate_expired"
  | "available";

const EXPIRY_WARNING_WINDOW_MS = 30 * 24 * 60 * 60 * 1_000;
const MAX_CLIENT_CERTIFICATE_PASSWORD_BYTES = 1_024;

export function clientCertificatePasswordValidationError(value: string): string | null {
  if (value.trim().length === 0) {
    return "クライアント証明書のパスワードを入力してください。";
  }
  if (new TextEncoder().encode(value).byteLength > MAX_CLIENT_CERTIFICATE_PASSWORD_BYTES) {
    return "クライアント証明書のパスワードは1,024 byte以下にしてください。";
  }
  return null;
}

export function resolveClientCertificateExpiryState(
  clientCertConfigured: boolean,
  expiresAt: string | null,
  now = Date.now(),
): ClientCertificateExpiryState {
  if (!clientCertConfigured) return "not_configured";
  if (!expiresAt) return "not_recorded";
  const expiresAtMs = Date.parse(expiresAt);
  if (!Number.isFinite(expiresAtMs)) return "not_recorded";
  if (expiresAtMs <= now) return "expired";
  if (expiresAtMs - now <= EXPIRY_WARNING_WINDOW_MS) return "expiring_soon";
  return "valid";
}

export function resolveRegisteredConnectionAccessUiState(
  input: {
    hasRegisteredEnvironment: boolean;
    isLoading: boolean;
    hasReadError: boolean;
    connectionKind: "standard" | "secure_access" | null;
    configurationState: "standard" | "configured" | "unavailable" | null;
    expiresAt: string | null;
  },
  now = Date.now(),
): RegisteredConnectionAccessUiState {
  if (!input.hasRegisteredEnvironment) return "not_applicable";
  if (input.isLoading) return "loading";
  if (input.hasReadError || input.connectionKind === null || input.configurationState === null) {
    return "connection_unavailable";
  }
  if (
    resolveClientCertificateExpiryState(
      input.connectionKind === "secure_access",
      input.expiresAt,
      now,
    ) === "expired"
  ) {
    return "certificate_expired";
  }
  if (input.configurationState === "unavailable") {
    return "connection_unavailable";
  }
  return "available";
}
